export function normalizeSchemeFulfillmentOverview(model) {
  if (!model) return null

  const p = model.profile || {}
  const board = model.board || {}

  return {
    profile: {
      region: p.region || '',
      priorityRegion: p.priorityRegion || '',
      response: p.response || '',
      stage: p.stage || '',
      deliveryMethod: p.deliveryMethod || '',
      deliveryTeam: p.deliveryTeam || '',
      deliverySupport: p.deliverySupport || '',
      scale: model.scaleLabel || '待补充'
    },
    cases: Array.isArray(model.cases)
      ? model.cases.map((c) => ({
          id: c.id,
          customer: c.customer || '',
          project: c.project || '',
          type: c.type || '',
          delivery: c.delivery || '',
          proof: c.proof || '',
          materialUrl: c.materialUrl || ''
        }))
      : [],
    board: {
      cityCount: Number(board.cityCount) || 0,
      teamCount: Number(board.teamCount) || 0,
      bidCount: Number(board.bidCount) || 0,
      assetCount: Number(board.assetCount) || 0
    },
    raw: model
  }
}
